export default {
  // addProjectAction (context, payload) {
  //   return new Promise((resolve, reject) => {
  //     context.commit('addProjectCommit', payload)
  //     resolve()
  //   })
  // },
}
